import ReactHtmlParser from 'html-react-parser'
import { url } from '../Funciones'
export default function LPSHorizontal({subenlace,subenlace_en,img,texto}){
    const idioma=localStorage.getItem("idioma") || "es"
    let array=subenlace.split(" ")
    return(
        <>
            <hr/>
            <div className='flex min600' style={{marginBottom:'1rem',width:'100%'}}>
                <div className='m1rem600' style={{marginRight:'1rem'}}>
                    <h2 style={{marginTop:'1rem',lineHeight:0}}><span>{array[0]}</span></h2>
                    <img src={img} style={{display:'block',width:'150px',height:'110px',margin:'0 auto'}}/>
                </div>
                <div style={{margin:'0 auto',width:'100%'}}>
                    <h2 style={{marginTop:'0',marginBottom:'0'}}>{idioma=="en"?subenlace_en.replace(array[0],""):subenlace.replace(array[0],"")}</h2>
                    <p>{ReactHtmlParser(texto)}</p>
                </div>
                <div className='flex' style={{alignItems:'center'}}>
                    <a className='btn-form' href={'/productos-y-servicios/'+url(subenlace)} style={{display:'block',width:'3rem',textAlign:'center',height:'fit-content',color:'white'}}>+ Info</a>
                </div>
            </div>
        </>
    )
}